/* eslint-disable react/no-danger */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { imagePrettyUrl, getAltText, textWordsLimit } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import OperatorBanner from 'gatsby-core-theme/src/components/atoms/header-operator-bannner';
import Rating from 'gatsby-core-theme/src/components/atoms/ratings';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { TrackingKeys } from '~constants/tracking-api'
import Verify from '~images/icons/verify';

import styles from './template-one-three.module.scss';

const TemplateOneThree = ({
  relation,
  type,
  name,
  image,
  sections = {},
  pageTemplate,
  icon = <Verify color="#295DD6" />,
  description,
  numOfStars,
  template = 'template_one',
  CostumeComponent = null,
  showRoundedRating = false,
  width = '179',
  height = '179',
  moduleName = TrackingKeys?.HEADERPAYMENT
}) => {
  const [isReadMore, setIsReadMore] = useState(true);

  const descriptionRef = useRef(null);
  const headerBonus = sections?.header?.modules?.find((bonus) => bonus?.name === 'bonus');

  const toggleReadMore = () => {
    descriptionRef.current.classList.add(styles.open);
    setIsReadMore(false);
  };

  return (
    <div
      className={`${styles.parentContainer} ${
        template === 'template_three' && styles.templateThreeParentContainer
      }`}
    >
      <div
        className={`${styles.container} ${
          template === 'template_three' && styles.templateThreeContainer
        }`}
      >
        <div
          className={`${styles.topSection} ${
            template === 'template_three' && styles.templateThreeTopSection
          }`}
        >
          <LazyImage
            loading="eager"
            src={imagePrettyUrl(image?.filename, width, height)}
            width={width}
            height={height}
            alt={getAltText(image, relation?.name)}
          />
          <div
            className={`${styles.topContent} ${
              template === 'template_three' && styles.templateThreeTopContent
            }`}
          >
            <div className={styles.name}>
              <h1>{name}</h1>
              {icon}
            </div>
            {relation?.rating ? (
              <StarRating
                numOfStars={numOfStars}
                rating={relation?.rating}
                icon={<FaStar title="Star Icon" />}
                showRoundedRating={showRoundedRating}
              />
            ) : (
              <div className={styles.ratingInactive}>
                <FaStar title="Star Icon" />
                <span>-</span>
              </div>
            )}
          </div>
        </div>

        {description && template !== 'template_three' && (
          <div
            ref={descriptionRef}
            className={`${styles.desc} ${
              description.split(' ').length > 60 && styles.showReadMore
            }`}
            role="button"
            onClick={toggleReadMore}
            onKeyDown={toggleReadMore}
            aria-label="continue reading"
            tabIndex={0}
            dangerouslySetInnerHTML={{
              __html:
                description.split(' ').length > 60 && isReadMore
                  ? `${textWordsLimit(description, 60)} <span class='${
                      styles.contReadText
                    }'>${useTranslate('cont_read', 'Continue reading')}</span>`
                  : description,
            }}
          />
        )}

        {CostumeComponent && <div className={styles.costumeComponent}>{CostumeComponent}</div>}

        <Rating item={relation} type={type} numOfStars={numOfStars} />
      </div>
      {headerBonus && (
        <div className={template !== 'template_three' ? styles.templateOneCta : styles.cta}>
          <OperatorBanner
            logo={headerBonus?.value?.logo}
            operator={headerBonus?.value}
            template={pageTemplate}
            moduleName={moduleName}
            clickedElement="header_operator_banner"
          />
        </div>
      )}
    </div>
  );
};

TemplateOneThree.propTypes = {
  relation: PropTypes.shape({
    type: PropTypes.string,
    template: PropTypes.string,
    name: PropTypes.string,
    rating: PropTypes.string,
    status: PropTypes.string,
  }),
  name: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.shape({
    filename: PropTypes.string,
  }),
  sections: PropTypes.shape({}),
  pageTemplate: PropTypes.string,
  numOfStars: PropTypes.number,
  template: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.element,
  CostumeComponent: PropTypes.node,
  showRoundedRating: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  moduleName: PropTypes.string,
};

export default TemplateOneThree;
